import { useEffect } from 'react';
import PageBody from 'utility/PageBody';
import PageHeader from 'utility/PageHeader';

import SearchBar from './searchBar';
import CarCatalogs from './carCatalogs';
import EditCarCatalogsModalProvider, {
  EditCarCatalogsModal,
} from './carCatalogsEditModal';
import CarMaintenanceProvider, {
  useCarMentenanceContext,
} from './carMaintenanceProvider';

const ShowRoomMaintenanceContent = () => {
  const { error } = useCarMentenanceContext();

  useEffect(() => {
    if (error && window.antdNotify) {
      window.antdNotify('Toyota 車款展示間', error, 'fail');
    }
  }, [error]);

  const section = [
    {
      hasTitle: false,
      title: 'Search',
      children: <SearchBar />,
    },
    {
      hasTitle: false,
      title: 'Car Catalogs',
      children: <CarCatalogs />,
    },
  ];

  // TODO: Update the page header for Toyota
  return (
    <>
      <PageHeader functionName={'toyota_show_room'} />
      <PageBody section={section} />
      <EditCarCatalogsModal />
    </>
  );
};

export default function ShowRoomMaintenancePage() {
  return (
    <CarMaintenanceProvider>
      <EditCarCatalogsModalProvider>
        <ShowRoomMaintenanceContent />
      </EditCarCatalogsModalProvider>
    </CarMaintenanceProvider>
  );
}
